// hooks/useRecaptchaEnterprise.js
import { useEffect, useRef, useState } from "react";

const SITE_KEY = process.env.REACT_APP_RECAPTCHA_V3_SITE_KEY;

export const useRecaptchaEnterprise = () => {
  const [ready, setReady] = useState(false);
  const readyPromiseRef = useRef(null);

  useEffect(() => {
    if (window.grecaptcha?.enterprise) {
      setReady(true);
      readyPromiseRef.current = Promise.resolve();
      return;
    }

    readyPromiseRef.current = new Promise((resolve) => {
      const script = document.createElement("script");
      script.src = `https://www.google.com/recaptcha/enterprise.js?render=${SITE_KEY}`;
      script.onload = () => {
        window.grecaptcha.enterprise.ready(() => {
          setReady(true);
          resolve();
        });
      };
      document.head.appendChild(script);
    });
  }, []);

  const executeRecaptcha = async (action) => {
    if (!window.grecaptcha?.enterprise) {
      await readyPromiseRef.current;
    }
    return new Promise((resolve, reject) => {
      window.grecaptcha.enterprise.ready(async () => {
        try {
          const token = await window.grecaptcha.enterprise.execute(SITE_KEY, {
            action,
          });
          resolve(token);
        } catch (err) {
          reject(err);
        }
      });
    });
  };

  return { ready, executeRecaptcha };
};